<template>
  <div id="app">
    <ConnectionStatus></ConnectionStatus>
    <NetworkMetrics></NetworkMetrics>
    <transition
        :name="routeAnimationName"
        :mode="routeAnimationMode"
        v-on:after-enter="$store.commit('RouteAnimation/resetAnimations')"
    >    
      <router-view class="router"></router-view>
    </transition>
  </div>
</template>

<script>
import RouteAnimator from './modules/lib/route-animations/route-animator'
import './App.scss'
import ConnectionStatus from './modules/lib/network-interface/ConnectionStatus'
import NetworkMetrics from './modules/lib/network-interface/NetworkMetrics'

import { mapGetters } from 'vuex'

export default {
  mixins: [RouteAnimator],
  name: 'App',
  components: {
    ConnectionStatus,
    NetworkMetrics,
  },

  data() {
    return {
      routeAnimatorName: 'drilldown',
    }
  },

  computed: {
      ...mapGetters('NetworkInterface', [
          'address',
          'players',
          'session',
          'room'
      ])
  },
  watch: {
      players: {
          handler (newVal, oldVal) {  
              console.log('players changed', newVal, oldVal)
          },
          deep: true,
      },
      room: {
        handler (newVal, oldVal) {
          console.log('App.vue watcher room changed', newVal, oldVal)

          if (newVal.playing && this.session.isController()) {
            this.navigateIfNeeded({ name: this.Game.routes.Controller.name, params: { } })
            // this.$_routeAnimation('drilldown', this.ANIMATIONS.slideRight)
          }
          if (!newVal.playing && this.session.isController()) {
            this.navigateIfNeeded({ name: this.Lobby.routes.Joined.name, params: { } })
            // this.$_routeAnimation('drilldown', this.ANIMATIONS.slideRight)
          }
        },
        deep: true,
      }
  },
  mounted () {
    // check if there is a previous session
    console.log('mounted', this.session)
    try {
      const orientation = typeof screen !== 'undefined' ? screen.orientation : null
      if (orientation && typeof orientation.lock === 'function') {
        const lockResult = orientation.lock('natural')
        if (lockResult && typeof lockResult.catch === 'function') {
          lockResult.catch(() => {})
        }
      }
    }
    catch (e) {
      // meh
      console.log('catch', e)
    }
  },
  methods: {
      navigateIfNeeded(location) {
        if (this.$route && location && this.$route.name === location.name) {
          return
        }

        this.$router.push(location).catch((error) => {
          if (error && error.name === 'NavigationDuplicated') {
            return
          }
          throw error
        })
      },
  }
}
</script>
